export const lemonlimeTokens = {
    tokens: {
        blendBackground: '#ffd848',
        blendIntersection: '#00a600',
        blendForeground: '#00d924',
        gradientColorZero: '#1dcb5d',
        gradientColorOne: '#ffa832',
        gradientColorTwo: '#ffa832',
        gradientColorThree: '#ffe85e',
        gradientColorZeroTransparent: '#1dcb5d00',
        gradientColorOneTransparent: '#ffa83200',
        gradientColorTwoTransparent: '#ffa83200',
        gradientColorThreeTransparent: '#ffe85e00',
        shadeOneColor: '#72d151',
        shadeTwoColor: '#15be1c',
        shadeThreeColor: '#13ad4c',
        shadeFourColor: '#008431'
    },
    themeTokens: {
        dark: {
            blendBackground: '#00d924',
            blendIntersection: '#fff5ad',
            blendForeground: '#ffd848'
        }
    },
    accents: {
        green: {
            tokens: {
                accentColor: '#15be53'
            },
            themeTokens: {
                dark: {
                    accentColor: '#14d433'
                }
            }
        },
        yellow: {
            tokens: {
                accentColor: '#eea800'
            },
            themeTokens: {
                dark: {
                    accentColor: '#ffce48'
                }
            }
        }
    }
};

//# sourceMappingURL=LemonLime.js.map